import { Component, EventEmitter, OnInit, Output } from '@angular/core';
// Plugins
import { Subscription, timer } from 'rxjs';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
// Models
import { UsersRO } from '@models/user/user.model.ro';
import { User } from '@models/user/user.model';
// Services
import { UserService } from '@services/user/user.service';

@Component({
  selector: 'sf-all-users-select',
  templateUrl: './all-users-select.component.html',
  styleUrls: ['./all-users-select.component.scss']
})
export class AllUsersSelectComponent implements OnInit {
	@Output() public userSelected = new EventEmitter<User>();

	public users: Array<User> = [];
	public selectedUser: User = null;
	public searchInfo: object = null;
	public searchColumn: string = 'fUsername';
	public loading: boolean = true;
	public scrollLoading: boolean = false;
	public searchLoading: boolean = false;
	private pageIndex: number = 1;
	private totle: number = 0;
	private readonly limit: number = 50;
	private searchTimer: Subscription = null;

	public constructor(private userService: UserService) { }

	public ngOnInit(): void {
		this.userService.userListPreviousParams = '';
		
		this.setSearchInfo();
		this.loadData();
	}

	public search(text: string): void | boolean {
		this.searchTimer?.unsubscribe();

		if (text?.trim() == '') return false;

		if (text == this.searchInfo[this.searchColumn].value) return false;

		this.searchInfo[this.searchColumn].value = text;
		this.searchInfo[this.searchColumn].visible = false;
		this.pageIndex = 1;
		this.searchLoading = true;
		this.users = [];

		this.searchTimer = timer(1000).subscribe(() => this.loadData());
	}

	public scrollToBottom(): void | boolean {
		if (this.scrollLoading || this.totle == this.users?.length) return false;

		this.scrollLoading = true;

		this.loadData();
	}

	public userChange(): void { 
		if (this.selectedUser === null) {
			this.loading = true;
			this.pageIndex = 1;
			this.userService.userListPreviousParams = '';
			this.searchInfo[this.searchColumn].value = '';
			this.users = [];

			this.loadData();
		} else {
			this.userSelected.emit(this.selectedUser);
		}
	}

	public setSearchInfo(): void {
		this.searchInfo = {
			uuid: { label: 'UUID', value: '' },
			fUsername: { label: 'Username', value: '' },
			fName: { label: 'Name', value: '' },
			fCountryCode: { label: 'Country Code', value: '' },
			fMobile: { label: 'Mobile', value: '' },
			fFirstName: { label: 'First Name', value: '' },
			fLastName: { label: 'Last Name', value: '' },
		};
	}

	public keeporder(): number {
		return 0;
	}

	private loadData(): void {
		let params: Partial<NzTableQueryParams> = {
			pageIndex: this.pageIndex,
			pageSize: this.limit,
			sort: []
		};

		this.userService.getUsers(params, this.searchInfo).subscribe((res: UsersRO): void | Array<User> => {
			if (!res?.result) return this.users = [];

			this.users = this.users.concat(res?.data?.items);
			this.totle = res?.data?.total_count;
			this.pageIndex++;
		}).add(() => {
			if (this.loading) this.loading = false;
			if (this.searchLoading) this.searchLoading = false;
			if (this.scrollLoading) this.scrollLoading = false;
		});
	}
}